import { FC } from 'react';
import { CustomersSettingsPageFormProvider } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.form.context';
import { EditCustomerForm } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.edit.component';

export const NewView: FC = () => {
  return (
    <CustomersSettingsPageFormProvider>
      <EditCustomerForm />
    </CustomersSettingsPageFormProvider>
  );
};
